<template>
  <Modal>
    <Modal.Title class="mb-[18px]! flex items-center gap-2.5">
      <CheckedSolidIcon class="size-[22px] shrink-0" aria-hidden="true" />
      Payment successful
    </Modal.Title>
    <Modal.Body>
      <p>
        Report credits successfully purchased. Your report credit balance has
        been updated.
      </p>
    </Modal.Body>
    <Modal.Footer class="tablet-h:mt-[18px]!">
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleContinue"
      >
        Continue
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { CheckedSolidIcon } from '@dacr/icons'

import { useDevice } from '@/shared/composables/useDevice'

const { isMobile } = useDevice()
const { close, triggerEvent } = useModal()

const handleContinue = () => {
  if (!triggerEvent('success')) close()
}
</script>
